import * as React from 'react';

var _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Svg1Password = function Svg1Password(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 121"
    }, props), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#clip0_1585_3749)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M60 .031c-33.14 0-60 26.86-60 60s26.86 60 60 60 60-26.86 60-60-26.86-60-60-60m0 4c30.93 0 56 25.07 56 56s-25.07 56-56 56-56-25.07-56-56 25.07-56 56-56",
        opacity: 0.502
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M60 4.031c30.93 0 56 25.07 56 56s-25.07 56-56 56-56-25.07-56-56 25.07-56 56-56"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0A2D4D",
        d: "M52 38.037c0-1.108.86-2.006 1.962-2.006h12.076c1.084 0 1.962.879 1.962 1.985v22.431c0 1.096-.66 2.579-1.49 3.325l-1.02.919c-.823.74-.865 1.965-.091 2.74l1.202 1.201c.773.773 1.399 2.318 1.399 3.405v9.988c0 1.108-.86 2.006-1.962 2.006H53.962c-1.084 0-1.962-.865-1.962-1.997V60.028c0-1.103.625-2.622 1.399-3.396l1.202-1.202a1.977 1.977 0 0 0 0-2.798l-1.202-1.202C52.626 50.658 52 49.113 52 48.025z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#198CFF",
        d: "M60 16.031c24.303 0 44 19.698 44 44 0 24.303-19.697 44-44 44s-44-19.697-44-44c0-24.302 19.697-44 44-44m0 12c-17.675 0-32 14.326-32 32 0 17.675 14.325 32 32 32s32-14.325 32-32c0-17.674-14.325-32-32-32"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "clip0_1585_3749"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 .031h120v120H0z"
    })))));
};

export { Svg1Password as ReactComponent };
//# sourceMappingURL=1Password.svg.es.js.map
